import { Modes } from '@/common.js';
import { IS_EMBEDDED_PARAM, IS_LOADED_FROM_EXTENSION_PARAM } from '@/router/router.const';
import { safeApplyFn } from '@/utils/helpers';

function applyFn(fn) {
	const { href } = window.location;
	const isExtensionContextExceptFlowBuilder =
		(href.includes(`${IS_LOADED_FROM_EXTENSION_PARAM}=true`) || href.includes('/extension')) &&
		!href.includes('/space') &&
		!href.includes('/features');
	const isEmbeddedContext = href.includes(`${IS_EMBEDDED_PARAM}=true`);
	const isWidgetContext = href.includes('/widgetLayout');
	const isSideBarContext = href.includes('/sidebar');
	if (isExtensionContextExceptFlowBuilder || isEmbeddedContext || isWidgetContext || isSideBarContext) {
		return;
	}

	if ([Modes.Production, Modes.Staging].includes(process.env.NODE_ENV)) {
		return safeApplyFn(fn);
	}
}
/* Private */
const DEFAULT_UPDATE_OBJECT = {
	hide_default_launcher: false,
};
let appUserId = null;

/* Public */
function init(user) {
	return applyFn(() => {
		if (!appUserId || appUserId !== user?.id) {
			appUserId = user?.id;
			if (window.Intercom) {
				console.log(`Booting Intercom`);
				window.Intercom('boot', {
					app_id: 's0g3847a',
					email: user.email,
					name: `${user.first_name} ${user.last_name}`,
					user_id: String(user.id),
					user_hash: user.intercom_user_hash,
					// alignment: 'left',
					horizontal_padding: 70,
					vertical_padding: 0,
					hide_default_launcher: true,
				});
			}
		}
	});
}
function update(properties, isInAppHelpEnabled = true) {
	const defaultObj = isInAppHelpEnabled ? { hide_default_launcher: true } : DEFAULT_UPDATE_OBJECT;
	return applyFn(() => window.Intercom?.('update', { ...defaultObj, ...properties }));
}

function show() {
	return applyFn(() => window.Intercom?.('show'));
}

function showNewMessage(prepopulatedMessage) {
	return applyFn(() => window.Intercom('showNewMessage', prepopulatedMessage));
}

function hideChatWindow() {
	return applyFn(() => !!window.Intercom('hide'));
}

function onHide(func) {
	return applyFn(() => !!window.Intercom('onHide', func));
}

function trackEvent(eventName, metadata) {
	return applyFn(() => window.Intercom('trackEvent', eventName, metadata));
}

function shutdown() {
	return applyFn(() => window.Intercom?.('shutdown'));
}

function loaded() {
	return applyFn(() => !!window.Intercom);
}

function booted() {
	return applyFn(() => !!window.Intercom?.booted);
}

function registerCountChangeCallback(callback) {
	return applyFn(() => {
		window.Intercom('onUnreadCountChange', (unreadCount) => {
			callback(unreadCount);
		});
		return;
	});
}

const IntercomService = {
	init,
	update,
	show,
	showNewMessage,
	trackEvent,
	shutdown,
	loaded,
	booted,
	hideChatWindow,
	onHide,
	registerCountChangeCallback,
};

export default IntercomService;
